import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderArrow = () => {
  return (
    <g>
      <path d="m1.064 5.01 4.57.007c.384 0 .7.283.751.648l.007.102v.673l5.546-.012c.505 0 .928.35 1.036.816l.02.119.006.114V9l1.938.023c.548.001.999.41 1.056.936l.006.115c0 .131-.026.261-.074.383l-.057.119-2.706 4.879a1.064 1.064 0 0 1-.805.537l-.129.008H1.064c-.549 0-1-.41-1.058-.935L0 14.951V6.059c0-.54.415-.985.948-1.042l.116-.007zm3.185 5.494-2.21 3.997h9.92l2.208-3.98-9.918-.017zM1.519 6.51v5.8l1.526-2.757c.166-.3.468-.499.807-.539l.129-.007 7.5-.009V7.925l-5.85.013a.758.758 0 0 1-.731-.55l-.02-.098-.008-.101v-.675L1.52 6.51zM12.25 0a.75.75 0 0 1 .743.648L13 .749v2.52l.72-.719.084-.072a.75.75 0 0 1 1.049 1.048l-.073.084-1.92 1.919-.084.072a.747.747 0 0 1-.382.144l-.144.003-.057-.002-.092-.013-.073-.018-.067-.025-.072-.034-.085-.055a.785.785 0 0 1-.084-.072L9.8 3.61a.749.749 0 0 1 .976-1.132l.084.072.64.64V.75a.75.75 0 0 1 .75-.75z" />
    </g>
  );
};

export default withIcon(IconFolderArrow);
